module.exports = __webpack_public_path__ + "static/media/5ton-variant-1.ff61a729.jpg";